import {createUseStyles} from 'react-jss';
import Spacing from '../../../style-helper/Spacing';

export default createUseStyles({
  contactNumber: {
    marginTop: [Spacing.quad],
  },
  contactNumberExperiment: {
    marginTop: Spacing.double,
    marginBottom: Spacing.triple,
  },
  
  collectionHelpLabel: {
    fontSize: 14,
    color: '#383838',
  },
});
